import { Component, Input } from '@angular/core';
import { GrundstueckId } from '../../../core/av-api';
import { TranslatePipe } from '@ngx-translate/core';
import { HaengigeGbGeschaefteIcpComponent } from '../haengige-gb-geschaefte-icp/haengige-gb-geschaefte-icp.component';
import { HaengigeGeoGeschaefteIcpComponent } from '../haengige-geo-geschaefte-icp/haengige-geo-geschaefte-icp.component';

@Component({
  selector: 'cap-haengige-geschaefte-auftraege-icp',
  imports: [TranslatePipe, HaengigeGbGeschaefteIcpComponent, HaengigeGeoGeschaefteIcpComponent],
  templateUrl: './haengige-geschaefte-auftraege-icp.component.html'
})
export class HaengigeGeschaefteAuftraegeIcpComponent {
  @Input()
  perimeter: Array<GrundstueckId>;
  @Input()
  hasRight: boolean = true;
  readonly loadOption: string = 'HAENGIGE';
}
